import { Image, Link } from "@chakra-ui/react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"

import barnesLogo from "@/assets/images/barnes-logo-white.svg"
import { PATHS } from "@/routing/paths"

type Props = {
  size: string
  // E.g. closes the mobile panel.
  onClick?: () => void
}

// BARNES seal of the menu, a link to the dashboard (ADR 0013, D1).
export const MenuLogo: React.FC<Props> = ({ size, onClick }) => {
  const intl = useIntl()

  return (
    <Link
      as={RouterLink}
      to={PATHS.DASHBOARD}
      onClick={onClick}
      aria-label={intl.formatMessage({ id: "menu.logo_home" })}
      display="inline-flex"
      flexShrink={0}
      _focusVisible={{ outline: "2px solid", outlineColor: "focus", outlineOffset: "2px" }}
    >
      <Image src={barnesLogo} alt="" h={size} w={size} objectFit="contain" />
    </Link>
  )
}
